// extracted by mini-css-extract-plugin
module.exports = {"loading":"dw","fullscreenWrapper":"dx","centeredSpinner":"dy","rotation":"dz","withoutLayer":"dA"};